import { AbstractToken, CSRFToken, Token } from './token.js';

export class TokenStorage<T extends AbstractToken> {
    constructor(private identifier: string, private token: T = null) {
        if (!identifier) {
            throw new Error('TokenStorage requires an identifier');
        }

        if (token !== null) {
            this.setToken(token);
        }
    }

    /**
     * save token to localStorage
     * @param token
     */
    public setToken(token: T) {
        TokenStorage.checkToken(token);

        // save token to localStorage
        window.localStorage.setItem(this.identifier, JSON.stringify(token));
    }

    /**
     * get token from localStorage
     */
    public getToken(): T|null {
        try {
            const tokenData = JSON.parse(window.localStorage.getItem(this.identifier));
            this.token = AbstractToken.fromJSON(tokenData) as T;
        } catch (e) {
            console.error(`Invalid ${this.identifier} in localStorage`, e);
            this.purge();
            return null;
        }

        return this.token;
    }

    public purge(): void {
        window.localStorage.removeItem(this.identifier);
    }

    public static checkToken(token: Token|CSRFToken|any): void {
        if (token instanceof Token && Token.valid(token) === false) {
            throw new Error('invalid token');
        } else if (token instanceof CSRFToken && CSRFToken.valid(token) === false) {
            throw new Error('invalid csrf token');
        }
    }
}
